"use strict";

(function () {
	var adpPopup = {};

	(function () {
		adpPopup = {
			sPrevious: window.scrollY,
			sDirection: "down",

			/*
			 * Initialize
			 */
			init: function () {
				adpPopup.popupInit();
				adpPopup.events();
			},

			/*
			 * Events
			 */
			events: function () {
				document.addEventListener("click", function (e) {
					const closeEl = e.target.closest(".popup-close");
					if (closeEl) {
						adpPopup.closePopup(closeEl);
					}

					const acceptEl = e.target.closest(".popup-accept");
					if (acceptEl) {
						adpPopup.acceptPopup(acceptEl);
						adpPopup.closePopup(acceptEl);
					}

					const ageCloseEl = e.target.closest(".age-verification__popup-close");
					if (ageCloseEl) {
						adpPopup.agePopup(ageCloseEl);
						adpPopup.closePopup(ageCloseEl);
					}

					const ageDeclineEl = e.target.closest(".age-verification__button-no");
					if (ageDeclineEl) {
						adpPopup.ageDeclined();
					}
				});

				document.addEventListener("keyup", function (e) {
					if (e.key === "Escape") {
						document.querySelectorAll('.popup-open[data-esc-close="true"]').forEach(function (popup) {
							adpPopup.closePopup(popup);
						});
					}

					if (e.key === "F4") {
						document.querySelectorAll('.popup-open[data-f4-close="true"]').forEach(function (popup) {
							adpPopup.closePopup(popup);
						});
					}
				});

				document.addEventListener("click", function (e) {
					if (!e.target.closest(".popup-overlay")) return;
					document.querySelectorAll('.popup-open[data-overlay-close="true"]').forEach(function (popup) {
						adpPopup.closePopup(popup);
					});
				});
			},

			/*
			 * Init popup elements
			 */
			popupInit: function () {
				document.addEventListener("scroll", function () {
					let scrollCurrent = window.scrollY;

					if (scrollCurrent > adpPopup.sPrevious) {
						adpPopup.sDirection = "down";
					} else {
						adpPopup.sDirection = "up";
					}

					adpPopup.sPrevious = scrollCurrent;
				});

				document.querySelectorAll(".popup").forEach(function (popup) {
					if (popup.dataset.openTrigger === "manual") {
						const selector = popup.dataset.openManualSelector;

						if (selector) {
							document.querySelectorAll(selector).forEach(function (trigger) {
								trigger.classList.add("popup-trigger");
							});

							document.addEventListener("click", function (e) {
								const triggerEl = e.target.closest(selector);
								if (!triggerEl) return;

								e.preventDefault();

								popup.classList.remove("popup-already-opened");
								if (triggerEl.classList.contains("popup") || triggerEl.closest(".popup")) {
									document.querySelectorAll(selector).forEach(function (matched) {
										const matchedPopup = matched.closest(".popup");
										if (matchedPopup) adpPopup.closePopup(matchedPopup);
									});
								}
								adpPopup.openPopup(popup);
							});
						}
					}

					if (!adpPopup.isAllowPopup(popup) && !popup.classList.contains("age-verification")) {
						return;
					}

					adpPopup.openTriggerPopup(popup);
				});
			},

			/*
			 * Trigger open popup
			 */
			openTriggerPopup: function (popup) {
				const trigger = popup.dataset.openTrigger;

				// Age Verification.
				if (trigger === "none" || !trigger) {
					const ageVerification = adpPopup.getStorage("popup-age-" + (popup.dataset.id || 0));
					if (!ageVerification) adpPopup.openPopup(popup);
				}

				// Time Delay.
				if (trigger === "delay") {
					setTimeout(function () {
						adpPopup.openPopup(popup);
					}, (popup.dataset.openDelayNumber || 0) * 1000);
				}

				// Exit Intent.
				if (trigger === "exit") {
					let showExit = true;
					document.addEventListener("mousemove", function (e) {
						const scroll = window.pageYOffset || document.documentElement.scrollTop;
						if (e.pageY - scroll < 7 && showExit) {
							adpPopup.openPopup(popup);
							showExit = false;
						}
					});
				}

				// Scroll Position.
				if (trigger === "scroll") {
					const pointScrollType = popup.dataset.openScrollType;
					const pointScrollPosition = popup.dataset.openScrollPosition;

					document.addEventListener("scroll", function () {
						if (pointScrollType === "px") {
							if (window.scrollY >= pointScrollPosition) {
								adpPopup.openPopup(popup);
							}
						}

						if (pointScrollType === "%") {
							if (adpPopup.getScrollPercent() >= pointScrollPosition) {
								adpPopup.openPopup(popup);
							}
						}
					});
				}

				// Accept Agreement.
				if (trigger === "accept") {
					const accept = adpPopup.getStorage("popup-accept-" + (popup.dataset.id || 0));
					if (!accept) {
						adpPopup.openPopup(popup);
					}
				}
			},

			/*
			 * Trigger close popup
			 */
			closeTriggerPopup: function (popup) {
				const trigger = popup.dataset.closeTrigger;

				// Time Delay.
				if (trigger === "delay") {
					setTimeout(function () {
						adpPopup.closePopup(popup);
					}, (popup.dataset.closeDelayNumber || 0) * 1000);
				}

				// Scroll Position.
				if (trigger === "scroll") {
					const pointScrollType = popup.dataset.closeScrollType;
					const pointScrollPosition = popup.dataset.closeScrollPosition;
					const initScrollPx = popup.dataset.initScrollPx;
					const initScrollPercent = popup.dataset.initScrollPercent;

					document.addEventListener("scroll", function () {
						if (pointScrollType === "px") {
							if (adpPopup.sDirection === "up" && window.scrollY < initScrollPx - pointScrollPosition) {
								adpPopup.closePopup(popup);
							}

							if (adpPopup.sDirection === "down" && window.scrollY >= Number(initScrollPx) + Number(pointScrollPosition)) {
								adpPopup.closePopup(popup);
							}
						}

						if (pointScrollType === "%") {
							if (adpPopup.sDirection === "up" && adpPopup.getScrollPercent() < initScrollPercent - pointScrollPosition) {
								adpPopup.closePopup(popup);
							}

							if (adpPopup.sDirection === "down" && adpPopup.getScrollPercent() >= Number(initScrollPercent) + Number(pointScrollPosition)) {
								adpPopup.closePopup(popup);
							}
						}
					});
				}
			},

			/*
			 * Open popup
			 */
			openPopup: function (popup) {
				// Hide body scroll.
				if (popup.dataset.bodyScrollDisable === "true") {
					document.body.classList.add("popup-scroll-hidden");
				}

				// Set storage of Limit display.
				const limit = parseInt(adpPopup.getStorage("popup-" + popup.dataset.id) || 0) + 1;

				adpPopup.setStorage("popup-" + popup.dataset.id, limit, {
					expires: popup.dataset.limitLifetime,
				});

				if (popup.classList.contains("popup-open")) {
					return;
				}

				// Check already opened.
				if (popup.classList.contains("popup-already-opened")) {
					return;
				}

				// Display popup.
				popup.classList.add("popup-open");

				// Set current scroll.
				popup.dataset.initScrollPx = window.scrollY;
				popup.dataset.initScrollPercent = adpPopup.getScrollPercent();

				// Open animation.
				const animation = popup.dataset.openAnimation;

				adpPopup.applyAnimation(popup, animation);

				// Init close trigger.
				adpPopup.closeTriggerPopup(popup);
			},

			/*
			 * Age popup
			 */
			agePopup: function (el) {
				const popup = el.closest(".popup");
				if (!popup) return;

				adpPopup.setStorage("popup-age-" + popup.dataset.id, 1, {
					expires: 360,
				});
			},

			/*
			 * Age declined
			 */
			ageDeclined: function () {
				document.querySelectorAll(".age-verification__question").forEach(function (el) {
					el.classList.remove("show");
				});
				document.querySelectorAll(".age-verification__declined").forEach(function (el) {
					el.classList.add("show");
				});
			},

			/*
			 * Accept popup
			 */
			acceptPopup: function (el) {
				const popup = el.closest(".popup");
				if (!popup) return;

				adpPopup.setStorage("popup-accept-" + popup.dataset.id, 1, {
					expires: 360,
				});
			},

			/*
			 * Close popup
			 */
			closePopup: function (el) {
				const popup = el.closest(".popup");
				if (!popup) return;

				// Close animation.
				const animation = popup.dataset.exitAnimation;

				adpPopup.applyAnimation(popup, animation, function () {
					// Already opened.
					popup.classList.add("popup-already-opened");

					// Hide popup.
					popup.classList.remove("popup-open");
				});

				// Remove classes from body.
				document.body.classList.remove("popup-scroll-hidden");
			},

			/*
			 * Checks whether a popup should be displayed or not
			 */
			isAllowPopup: function (popup) {
				const limitDisplay = parseInt(popup.dataset.limitDisplay || 0);
				const limitDisplayStorage = parseInt(adpPopup.getStorage("popup-" + popup.dataset.id));

				if (limitDisplay && limitDisplayStorage && limitDisplayStorage >= limitDisplay) {
					return;
				}

				return true;
			},

			/*
			 * Apply animation
			 */
			applyAnimation: function (popup, name, callback) {
				const overlayName = typeof callback === "function" ? "popupExitFade" : "popupOpenFade";
				const overlay = popup.nextElementSibling && popup.nextElementSibling.classList.contains("popup-overlay")
					? popup.nextElementSibling
					: null;

				if (overlay) {
					overlay.classList.add("popup-animated", overlayName);
					overlay.addEventListener(
						"animationend",
						function handler() {
							overlay.classList.remove("popup-animated", overlayName);
							overlay.removeEventListener("animationend", handler);
						},
						{ once: true }
					);
				}

				const wrap = popup.querySelector(".popup-wrap");
				if (wrap) {
					wrap.classList.add("popup-animated", name);
					wrap.addEventListener(
						"animationend",
						function handler() {
							wrap.classList.remove("popup-animated", name);
							wrap.removeEventListener("animationend", handler);

							if (typeof callback === "function") {
								callback();
							}
						},
						{ once: true }
					);
				} else if (typeof callback === "function") {
					callback();
				}
			},

			/*
			 * Get cookie
			 */
			getCookie: function (name) {
				const matches = document.cookie.match(
					new RegExp("(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") + "=([^;]*)")
				);
				return matches ? decodeURIComponent(matches[1]) : undefined;
			},

			/*
			 * Get local storage
			 */
			getStorage: function (key) {
				const item = localStorage.getItem(key);
				if (item) {
					try {
						const parsed = JSON.parse(item);
						if (parsed.expires && Date.now() > parsed.expires) {
							localStorage.removeItem(key);
							return undefined;
						}
						return parsed.value;
					} catch {
						return undefined;
					}
				}
				const cookieValue = adpPopup.getCookie(key);
				if (cookieValue !== undefined) {
					adpPopup.setStorage(key, cookieValue);
					return cookieValue;
				}

				return undefined;
			},

			/*
			 * Set local storage
			 */
			setStorage: function (key, value, options = {}) {
				const data = {
					value,
					expires: null,
				};
				if (options.expires) {
					const expiresDate = new Date();
					expiresDate.setDate(expiresDate.getDate() + parseInt(options.expires, 10));
					data.expires = expiresDate.getTime();
				}
				localStorage.setItem(key, JSON.stringify(data));
			},

			/*
			 * Get scroll percent
			 */
			getScrollPercent: function () {
				const h = document.documentElement,
					b = document.body,
					st = "scrollTop",
					sh = "scrollHeight";
				return ((h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight)) * 100;
			},
		};
	})();

	function boot() {
		adpPopup.init();
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", boot);
	} else {
		boot();
	}

	document.addEventListener("shopify:section:load", function () {
		adpPopup.init();
	});
})();
